import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'classColorArchived',
    standalone: false
})
export class ClassColorArchivedPipe implements PipeTransform {
    static format(archived:boolean): string {
        return !!archived ? 'gup-U-color--200' : '';
    }

    transform(archived:boolean): string {
        return ClassColorArchivedPipe.format(archived);
    }
}
